import { apiFetch } from "../lib/api";
import type { BrokerKind } from "./brokers";

/** The caller's OWN limits — drives the Brokers page, the deployment broker
 *  picker, the Strategies empty state and the Backtests/Data nav gating. */
export interface BrokerPolicyView {
  broker: BrokerKind;
  enabled: boolean;
  max_accounts: number;
  used: number;
}

export interface MyPolicy {
  brokers: BrokerPolicyView[];
  /** Connections that may still be used for order routing. A connection that
   *  fell outside a lowered cap stays visible and deletable but not tradeable. */
  in_policy_connection_ids: string[];
  out_of_policy_connection_ids: string[];
  strategy_keys: string[];
  can_backtest: boolean;
  can_backfill: boolean;
  is_admin: boolean;
}

export async function getMyPolicy(): Promise<MyPolicy> {
  return apiFetch<MyPolicy>("/users/me/policy");
}

export const MY_POLICY_KEY = ["me", "policy"] as const;
